import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_authed/alerts")({
  beforeLoad: () => {
    throw redirect({ to: "/monitoring" });
  },
  component: () => null,
});
